import {BarChartConfig, ChartOrientation, ChartType, LineChartConfig, MapChartConfig, ScatterplotChartConfig} from "@thinknum/d3-charts";

export const deserializeConfig = (config: any): LineChartConfig | MapChartConfig | BarChartConfig | ScatterplotChartConfig => {
  if (config.type === ChartType.MAP) {
    return config;
  } else if (config.type === ChartType.LINE) {
    return deserializeLineConfig(config);
  } else if (config.type === ChartType.BAR) {
    return deserializeBarConfig(config);
  } else if (config.type === ChartType.SCATTERPLOT) {
    return deserializeScatterplotConfig(config);
  } else {
    return deserializeLineConfig(config);
  }
}

export const deserializeLineConfig = (config: any): LineChartConfig => {
  return {
    ...config,
    type: ChartType.LINE,
    series: config.series.map(series => ({
      ...series,
      data: series.data.map(d => ({
        ...d,
        date: new Date(d.date)
      }))
    }))
  }
};

export const deserializeScatterplotConfig = (config: any): ScatterplotChartConfig => {
  return {
    ...config,
    type: ChartType.SCATTERPLOT,
    series: config.series.map(series => ({
      ...series,
      points: series.data.map(d => ({
        ...d,
        date: new Date(d.date)
      }))
    }))
  }
};

export const deserializeMapConfig = (config: any): MapChartConfig => {
  return {
    ...config,
    type: ChartType.MAP,
  };
}

export const deserializeBarConfig = (config: any): BarChartConfig => {
  return {
    ...config,
    type: ChartType.BAR,
    orientation: config.orientation || ChartOrientation.HORIZONTAL,
  };
}

export const serializeMapConfig = (config: MapChartConfig): string => {
  return JSON.stringify({
    ...config,
    type: ChartType.MAP,
  });
};

export const serializeBarConfig = (config: BarChartConfig): string => {
  return JSON.stringify({
    ...config,
    type: ChartType.BAR,
  });
}

export const serializeLineConfig = (config: LineChartConfig): string => {
  const series = config.series.map(series => ({
    ...series,
    data: series.data.map(d => ({
      date: d.date && d.date.getTime(),
      value: d.value
    }))
  }));

  return JSON.stringify({
    ...config,
    type: ChartType.LINE,
    series
  });
};
